import { useTranslation } from '@framework/i18n';
import { BrandedPath, LinkButton } from '@framework/ui';
import { Result } from 'antd';

/**
 * Schermata di conferma mostrata dopo un voto inviato con successo, condivisa
 * dai widget di voto CTS e CS: sostituisce il form così il voto non può essere
 * inviato due volte.
 */
export function VoteSuccessResult() {
  const { t } = useTranslation();

  return (
    <Result
      status="success"
      title={t(
        'success-submit-vote-widget.voto-inviato',
        'Voto inviato con successo',
      )}
      extra={
        <LinkButton type="link" to={'/' as BrandedPath}>
          {t(
            'success-submit-vote-widget.torna-alle-istanze',
            'Torna alle Domande',
          )}
        </LinkButton>
      }
    />
  );
}
